import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Parametro } from "app/types/Parametro";
import globalMU from "globalMU";
import React from "react";

const estiloreservaProduto = require("./reserva-produto.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

export type EntitesReservaProduto = {
  CodigoCliente: number,
  CodigoFilial: string,
  CodigoFilialRetirada: string,
  Data: string,
  DataPedido: string,
  FilialTransferencia: string,
  NomeCliente: string,
  NomeVendedor: string,
  NumeroPedido: number,
  QuantidadeDeposito: number,
  QuantidadeReservada: number,
  SituacaoVenda: string,
  Encomenda: string,
  FonteDeReceita?: string, // 487678
  UserMessage: string,
  Transforming: boolean
}

export type PesquisaSubConsultasReserva = {
  CodigoFilial: string
  Codigo: string
  NumeroPagina: number
  TamanhoPagina: number
}

export type ReservaProdutoProps = {
  dados: PagedMessageResponse<EntitesReservaProduto>;
  mostrarColunaEncomenda: boolean;
  parametros?: Parametro[]; // 487678
};

export const ReservaProduto = (props: ReservaProdutoProps) => {

  const valorParametro = (nome: string) => props.parametros.find((p) => p.Nome == nome)?.Valor;
  const paramUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA = valorParametro("UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA") ==="S"


  const tableHead = <div className="_table-row"
    id="reservaProdutos_tableHead"
  >
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Pedido
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Filial
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Filial Retirada
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Filial Transf.
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Cliente
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Quantidade
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Data Pedido
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Entrega
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Vendedor
    </div>
    <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Situação
    </div>
    {props.mostrarColunaEncomenda && <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
      Enc
    </div>}
    {paramUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA && 
      <div className={`_table-cell ${estiloreservaProduto.tableCellHeader}`}>
        Fonte de Receita
      </div>}
  </div>

  const tableBody = props?.dados?.Entities?.filter(c => c.NumeroPedido > 0)?.map((dado, index) => (
    <div className={`_table-row ${estiloreservaProduto.linha}`}
      id={`reservaProdutos_tableBody_${index}`}
      key={index}
    >
      <div
        className={`_table-cell _text-center ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_NumeroPedido`}
      >
        {dado?.NumeroPedido}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_CodigoFilial`}
      >
        {dado?.CodigoFilial}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_FilialRetirada`}
      >
        {dado?.CodigoFilialRetirada}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_FilialTransf`}
      >
        {dado?.FilialTransferencia}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_NomeCLiente`}
      >
        {dado?.NomeCliente}
      </div>

      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_QuantidadeReservada`}
      >
        {globalMU.formatarValorNumerico(dado?.QuantidadeReservada,3,false)}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_DataPedido`}
      >
        {globalMU.formatDate(dado?.DataPedido)}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_Data`}
      >
        {globalMU.formatDate(dado?.Data)}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_NomeVendedor`}
      >
        {dado?.NomeVendedor}
      </div>
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_SituacaoVenda`}
      >
        {dado?.SituacaoVenda}
      </div>
      {props.mostrarColunaEncomenda && <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_Encomenda`}
      >
        {dado?.Encomenda}
      </div>}

      {paramUTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA && 
      <div
        className={`_table-cell  ${estiloreservaProduto.tableCellBody}`}
        id={`reservaProdutos_tableBody_${index}_FonteDeRenceira`}
      >
        {dado?.FonteDeReceita}
      </div>}
      

    </div>
  ))

  const totais = () => {
    const quantidadePedidoReservadaTotal = () => {
      let total = 0
      props.dados?.Entities?.forEach((x) => total += x.QuantidadeReservada)
      return total
    }
  
    const quantidadDepositoReservadaTotal = () => {
      let total = 0
      props.dados?.Entities?.forEach((x) => total += x.QuantidadeDeposito)
      return total
    }

    return <>
      <h3 className={estiloreservaProduto.totais}
        id="reservaProdutos_totais_titulo"
      >Totais</h3>
      <div id="reservaProdutos_totais" className={estiloreservaProduto.form}>
        <label>Reserva de Pedidos</label>
        <div id="reservaProdutos_totais_ReservaDePedido">{globalMU.formatarValorNumerico(quantidadePedidoReservadaTotal(), 3, false)}</div>

        <label>Reserva em Depósitos</label>
        <div>{globalMU.formatarValorNumerico(quantidadDepositoReservadaTotal(), 3, false)}</div>

        <label>Total de Reservas</label>
        <div>{globalMU.formatarValorNumerico((quantidadePedidoReservadaTotal() + quantidadDepositoReservadaTotal()), 3, false)}</div>
      </div>
    </>
  }

  return (
    <>
      <div className={estiloTabela.containerRolavel}>
      <div className={`_table _w-full _border-collapse ${estiloreservaProduto.table}`}>
        <div className="_table-header-group">
          {tableHead}
        </div>
        <div className="_table-row-group">
          {tableBody}
        </div>
      </div>
      </div>
      {totais()}
      {<section style={{ marginBottom: "100px" }} />}{<section style={{ marginBottom: "100px" }} />}
    </>
  )
} 